class MapFilterFormController {
  constructor() {
    this.name = 'mapFilterForm';
  }
}

export default MapFilterFormController;
